import React from 'react'
import {findDOMNode} from "react-dom"

import HintPopover from "../../../../../../src/core/gd-ui/hint-popover/hint-popover"

//@ts-ignore
import InlineInput from '../../../../../core/gd-components/inline-edit/input/input'

type Props = {
    className?      : string
    style?          : any

    name            : string

    maxWidth?       : number

    withPadding?    : boolean
    noLeftPadding?  : boolean
    editable?       : boolean

    onChange?       : func
}

export default class HeaderAppTitle extends React.Component<Props,any> {
    public input :any

    static defaultProps = {
        maxWidth    : 350,
        withPadding : true
    }

    state = {
        isEditing   : false,
        useHint     : false
    }

    componentDidMount() {
        this._checkHintUsage()
    }

    componentDidUpdate() {
        this._checkHintUsage()
    }

    _checkHintUsage = () => {
        const useHint = gd.utils.getTextExceedsNodeWidth(this.props.name, findDOMNode(this), 10, 16, null, {fontWeight: 700})

        if (this.state.useHint !== useHint) {
            this.setState({
                useHint: useHint
            })
        }
    }

    handleClickOutside = () => {this.setViewState()}

    setViewState = () => {this.setState({isEditing: false})}

    onEditClick = () => {
        if (!this.props.editable) return;

        this.setState({isEditing: true}, () => {
            this.input.focus();
        });
    }

    onBlur = () => {
        const newValue = this.input.state.value

        if (newValue.trim() === '') return

        if (this.props.onChange && this.props.name !== newValue) this.props.onChange(newValue)

        this.setViewState()
    }

    render() {
        const classes = Classes("ui5-title-app-name", this.props.className, {
            'with-padding'                      : this.props.withPadding,
            'no-left-padding'                   : this.props.withPadding && this.props.noLeftPadding,
            ['max-w-{0}'.f(this.props.maxWidth)]: !!this.props.maxWidth,
            editable                            : this.props.editable && !this.state.isEditing,
            'is-editing'                        : this.state.isEditing
        })

        if (this.state.isEditing)
            return (
                <div className={classes}>
                    <InlineInput ref        = {(r: any) => this.input = r}
                                 className  = "gd-input big"
                                 style      = {this.props.style}
                                 value      = {this.props.name}
                                 onBlur     = {this.onBlur}/>
                </div>
            )
        else
            return (
                <div className={classes} style={this.props.style} onClick={this.onEditClick}>
                    {this.props.name}
                    {this.state.useHint && <HintPopover hint={this.props.name} multiline={true} showDelay={500}/>}
                </div>
            )
    }
}
